export const primaryFont = '"Roboto", "Helvetica Neue", sans-serif' // default ionic md font
export const monospaceFont = '"Inconsolata", monospace'

export default {
	primaryFont,
	monospaceFont
}
